import React from "react";
import { Row, Col, Image } from "react-bootstrap";

import logo from "../assets/logo_light_banner.png"
import background from "../assets/bg.jpg";

import { FaAddressCard, FaFacebookSquare, FaInstagramSquare, FaLinkedin, FaMapMarked, FaTwitterSquare } from "react-icons/fa";
import { SectionTitle } from "../components/SectionTitle";
import { AltFeatureItem } from "../components/AltFeatureItem";


export class Contact extends React.Component {
    render() {
        return (
            <section id="contact" style={{ backgroundImage: `url(${background})` }}>
                <div>
                    <SectionTitle title="Contact US" />
                    <Row>
                        <Col xs={{ span: 12, offset: 0 }} lg={{ span: 6, offset: 0 }}>
                            <Image src={logo} fluid />
                        </Col>
                        <Col xs={{ span: 12, offset: 1 }} sm={{ span: 12, offset: 3 }} lg={{ span: 3, offset: 0 }}>
                            <AltFeatureItem icon={FaAddressCard} title="Contact" text={<>Email: info@comnify.tech<br />Phone: +90 312 514 16 61</>} />
                        </Col>
                        <Col xs={{ span: 12, offset: 1 }} sm={{ span: 12, offset: 3 }} lg={{ span: 3, offset: 0 }}>
                            <AltFeatureItem icon={FaMapMarked} title="Address" text={<>Comnify Teknoloji A.Ş.<br /><br />Bilkent CYBERPARK<br />Üniversiteler Mah.<br />Şehit Mustafa Tayyarcan Cad.<br />Cyberpark Tepe Binası No:5/208<br />Çankaya/Ankara/Türkiye</>} />
                        </Col>
                    </Row>
                    <Row className="social_media">
                        <Col xs={{ span: 12 }}>
                            <a href="https://www.instagram.com/comnify/">{< FaInstagramSquare />}</a>
                            <a href="https://www.linkedin.com/company/comnify">{< FaLinkedin />}</a>
                        </Col>
                    </Row>
                </div>
            </section>
        );
    }
}
